import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import './styles.css';
import ContactForm from '../../../components/ContactForm';
import { listingPropTypes } from '../../../utils/commonPropTypes';

import { injectIntl } from 'react-intl';
import { getTitle, addNotModifiedResizeParams, isValidImageUrl, LOGO_SIZES, setImageUrlForResizer } from '../../../utils/listingHelper';
import { getCurrentLocale } from '../../../utils/language';
import { getMessages } from '../../../tppServices/translations/messages';
import ImageWithErrorHandler from '../../../components/ImageWithErrorHandler';

// TODO - once we have a title for all languages, remove this
export const shouldContactTitleHide = (locale) => {
  const isEnglishLocale = ['us', 'au', 'en', 'uk'].includes(locale);
  return isEnglishLocale ? '' : 'hide-contact-title';
};

const DetailsManufacturerContact = (props) => {
  let showCountry = true;
  let showZipCode = false;
  let orderInputs = ['name', 'email', 'phone', 'country', 'comments'];
  const messages = getMessages();

  if (getCurrentLocale() === 'us') {
    showZipCode = true;
    showCountry = false;
    orderInputs = ['name', 'email', 'phone', 'zip', 'comments'];
  }

  const {
    listing,
    intl: { formatMessage: t, locale },
    brand,
    leadType
  } = props;
  let brandId, isBranded, itemId, oemId, prePopulatedText;
  if (listing) {
    oemId = get(listing, 'owner.id');
    brandId = get(listing, 'oemDetails.brandId');
    isBranded = !!listing.oemDetails;
    itemId = listing.id;
    prePopulatedText = t(messages.contactForm.prePopulatedText, {
      listingTitle: getTitle(listing)
    });
  } else if (brand) {
    oemId = brand.partyId;
    brandId = brand.brandId;
    isBranded = true;
    itemId = brand.partyId;
    prePopulatedText = t(messages.contactForm.prePopulatedTextBrandedSrp, {
      brandName: brand.name
    });
  }

  let logoUrl = '';
  const manufacturerMakeLogo = get(listing, 'owner.logos.default');
  if (isValidImageUrl(manufacturerMakeLogo)) {
    const { isUrlValidForResizer, url } = setImageUrlForResizer(manufacturerMakeLogo);
    logoUrl = isUrlValidForResizer ? addNotModifiedResizeParams(url, {
      width: LOGO_SIZES.detailsManufacturer.w,
      height: LOGO_SIZES.detailsManufacturer.h,
    }, false) : url;
  }

  return (
    <div
      id={`details-manufacturer-contact${brand ? '-branded' : ''}`}
      className="details-contact open"
    >
      <div className={`contact-area ${shouldContactTitleHide(locale)}`}>
        <div className="seller-information">
          {listing && (
            <div className="manufacturer-logo">
              {logoUrl && <ImageWithErrorHandler
                src={logoUrl}
                alt={listing.make}
                noFallbackImage={true}
              />}
            </div>
          )}
        </div>

        <ContactForm
          open={true}
          productTrack={false}
          contactSubmitTrack={true}
          id="oem-details-contact-form"
          prePopulatedText={prePopulatedText}
          placeholderText={{
            name: t(messages.contactForm.fullName),
            email: t(messages.contactForm.yourEmail),
            phone: t(messages.contactForm.yourPhone),
            zip: t(messages.postalCode),
            country: t(messages.contactForm.selectCountry),
            comments: t(messages.contactForm.comments)
          }}
          isOemManufactuer={true}
          orderInputs={orderInputs}
          showZipCode={showZipCode}
          showCountry={showCountry}
          labelText={{
            name: t(messages.contactForm.firstName),
            email: t(messages.contactForm.email),
            phone: t(messages.contactForm.phone),
            zip: t(messages.postalCode),
            country: t(messages.contactForm.country),
            comments: t(messages.contactForm.comments)
          }}
          listing={listing}
          itemId={itemId}
          leadType={leadType}
          contactButtonText={t(messages.contactGroup.contact)}
          oemId={isBranded && oemId}
          brandId={isBranded && brandId}
          showTermsAndPrivacy={!!brand}
          mode={ContactForm.MODES.details}
          title={t(messages.brandedOemSearch.manufacturerContact.title)}
        />
      </div>
    </div>
  );
};

DetailsManufacturerContact.defaultProps = {
  mode: ContactForm.MODES.details
};

DetailsManufacturerContact.propTypes = {
  listing: listingPropTypes,
  id: PropTypes.string,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
    messages: PropTypes.object,
    locale: PropTypes.string
  }).isRequired,
  brand: PropTypes.object,
  leadType: PropTypes.oneOf(Object.values(ContactForm.TYPES))
};

export default injectIntl(DetailsManufacturerContact);
